import { Collapse, Divider } from 'antd';
import {
  InspectionPOItem,
  InspectionResultType
} from 'app/modules/inspection/types';
import React from 'react';
import { ElementCriteria } from './config';
import { Descriptions, Status } from 'app/modules/ui';
import { PRESETS_INSPECTION_RESULT } from 'app/modules/inspection/constants';
import classes from './CriteriaItem.module.scss';
import cn from 'classnames';

type CriteriaItemProps = {
  //   type: ItemType;
  ordinal: number;
  po: InspectionPOItem;
  item: {
    label: string;
    name: string;
    value: {
      [key: string]: any; // Don't know what type this should be
    };
    progress: string;
    result: InspectionResultType;
    fields: {
      [key: string]: any; // Don't know what type this should be
    };
  };
};

export const CriteriaItem = (props: CriteriaItemProps) => {
  const { item, po, ordinal } = props;
  const { label, name, result } = item;
  const Element = ElementCriteria[name];
  const [active, setActive] = React.useState(false);
  const [textResult, color] = React.useMemo(() => {
    return PRESETS_INSPECTION_RESULT.get(result) || ['', 'default'];
  }, [result]);

  return (
    <Collapse
      className={cn(classes.collapse, {
        [classes['collapse--active']]: active
      })}
      onChange={(key) => {
        if (Array.isArray(key)) {
          setActive(key.includes(name));
        } else {
          setActive(key === name);
        }
      }}
    >
      <Collapse.Panel
        key={name}
        className={classes['collapse__panel']}
        header={
          <div className={classes['collapse__panel__header']}>
            <Descriptions
              colon={false}
              value={{ remark: item?.value?.remark ?? '/' }}
              items={[
                {
                  label: `${ordinal} ${label}`,
                  dataIndex: 'title',
                  render: () => {
                    return null;
                  }
                },
                {
                  label: 'Result:',
                  dataIndex: 'result',
                  render: () => {
                    return (
                      <Status
                        type="text"
                        color={color as string}
                        value={textResult}
                      />
                    );
                  }
                }
              ].filter((item) => {
                if (item.dataIndex === 'result') {
                  return name !== 'importantRemarksAttachments';
                }
                return true;
              })}
            />
            <div className={classes['collapse__panel__header__content']}>
              <Divider />
              <Descriptions
                value={{ remark: item?.value?.remark ?? '/' }}
                items={[
                  {
                    label: 'Remark',
                    dataIndex: 'remark'
                  }
                ]}
              />
            </div>
          </div>
        }
      >
        <Divider style={{ marginTop: 4, marginBottom: 16 }} />
        {Element ? (
          <Element
            progress={item.progress}
            result={item.result}
            poItem={po}
            fields={item.fields}
            value={item.value}
          />
        ) : null}
      </Collapse.Panel>
    </Collapse>
  );
};
